import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { baseColors } from '../../Themes/colors';
var CardRoot = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: baseColors.fullWhite,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 12,
    padding: '10px 12px',
    gap: 12,
    width: '100%',
}); });
var IconWrapper = styled(Box)(function () { return ({
    width: 36,
    height: 36,
    borderRadius: '50%',
    backgroundColor: baseColors.greyPreset[55],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg, & span': {
        fontSize: 18,
        color: baseColors.darkPreset[10],
    },
}); });
var ProgressBar = styled(Box)(function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 0 : _b, barcolor = _a.barcolor;
    return ({
        height: 4,
        borderRadius: 4,
        backgroundColor: baseColors.greyPreset[45],
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: "".concat(Math.min(Math.max(fill, 0), 100), "%"),
            backgroundColor: barcolor !== null && barcolor !== void 0 ? barcolor : baseColors.successPreset[80],
            borderRadius: 4,
        },
    });
});
var ScoreBadge = styled(Box)(function () { return ({
    borderRadius: 8,
    padding: '6px 12px',
    flexShrink: 0,
}); });
var CreditScoreCard = function (_a) {
    var icon = _a.icon, label = _a.label, score = _a.score, _b = _a.progress, progress = _b === void 0 ? 0 : _b, progressColor = _a.progressColor, scoreColor = _a.scoreColor, scoreBgColor = _a.scoreBgColor, scoreBorderColor = _a.scoreBorderColor;
    return (React.createElement(CardRoot, null,
        icon && React.createElement(IconWrapper, null, icon),
        React.createElement(Stack, { flex: 1, gap: 0.75 },
            React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[30] }, label),
            React.createElement(ProgressBar, { fill: progress, barcolor: progressColor })),
        React.createElement(ScoreBadge, { sx: {
                backgroundColor: scoreBgColor || baseColors.successPreset[60],
                border: "1px solid ".concat(scoreBorderColor || baseColors.successPreset[70]),
                color: scoreColor || baseColors.successPreset[50],
            } },
            React.createElement(Typography, { variant: "body2", fontWeight: 500, color: "inherit" }, score))));
};
export default CreditScoreCard;
